var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-arc',{ref:"arcFaceThree",attrs:{"config":_vm.config},on:{"click":_vm.onClick}}),_vm._l((_vm.conventions),function(convention,index){return _c('v-path',{key:index,attrs:{"config":convention}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }